/**
 * The Flightdeck mark (web/brand/mark.svg, docs/brand.md). Inlined rather than loaded as
 * an image so it paints with the page and costs no request. Its two colours are the same
 * on light and dark grounds, so they are not theme variables. Decorative: the wordmark
 * beside it names the link.
 */
export default function Logo() {
  return (
    <svg
      className="logo"
      viewBox="0 0 64 64"
      fill="none"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 30 L32 10 L52 30" stroke="#ff5a1f" />
      <path d="M12 52 L32 32 L52 52" stroke="#4f7cff" />
    </svg>
  )
}
